import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config.json";
import { Button, Modal, Form } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { sweetAlert } from "../../../utils/UniversalFunction";

const questionData = {
  289: "Total Diesel consumed within the operational boundary of the company* (in Liters)",
  292: "Total LPG consumed within the operational boundary of the company*  (in Kgs)",
  293: "Total Petrol consumed within the operational boundary of the company*  (in Liters)",
  295: "Total PNG consumed within the operational boundary of the company*  (in SCM)",
  391: "Total Groundwater consumption* ( in KL)",
  392: "Total Water Bill (in Rs.)",
  393: "Total wastewater generated* ( in KLD)",
  394: "Total Wastewater treated(STP/ETP)* ( in KL)",
  395: "Total treated water reused(Flushing/CT etc.)* (in KL)",
  396: "Water recycling/reuse percentage* ",
  399: "Total cost for STP treatment*(in Rs.)",
  400: "Total non-hazardous solid waste generation (black category general waste)* (Kg)",
  401: "Total non-hazardous waste sent to landfil(construction waste/other waste to landfill)* (Kg)",
  402: "Total packaging waste (Non-Plastic-Cardboard waste) generated* (Kg)",
  404: "Total packaging waste (Plastic) generated* (Kg)",
  408: "Total food waste generated/Kitchen Waste* (Kgs)",
  409: "Total biomedical waste generated* (Kg)",
  410: "Total biomedical waste disposal Bill* (in Rs.)",
  412: "Total e-waste generated* (Kg)",
  417: "Total Petrol cost* (in Rs.)",
  418: "Total Diesel cost* (in Rs.)",
  419: "Total PNG cost* (in Rs.)",
  421: "Total GHG emissions due to consumption of Petrol",
  422: "Total GHG emissions due to consumption of Diesel",
  424: "Total GHG emissions due to consumption of PNG",
  425: "Total GHG Emissions due to GRID electricity",
  426: "Total electricity consumption (Captive Power Plant - Natural Gas)*  (in KWh)",
  427: "Total Emissions due to Electricity Power plant (Captive Power Plant - Natural Gas)",
  428: "Total Electricity consumption through DG*  (in KWh)",
  429: "Total electricity consumption from Renewable energy (via PPA)*  (in KWh)",
  430: "Total electricity consumption from Renewable energy (rooftop solar)*  (in KWh)",
  431: "Total Electricity Bill *(in Rs.)",
  432: "Current employees by Gender (in %) Male",
  433: "Current employees by Gender (in %) Female",
  434: "Employees less than 30 years of age (%)",
  435: "Employees between 30-50 years of age (%)",
  436: "Employees more than 50 years of age (%)",
  437: "Manpower turnover rate(FTE atrition rate) in %",
  438: "Average training hours per employee (in Hours)",
  439: "Number of Mock Drills ",
  440: "Fire Safety Audits",
  441: "Number of Safety Trainings",
  442: "Number of Safety Committee Meetings",
  443: "Fatalities (Number of cases)",
  444: "High-consequence injuries (Number of cases)",
  445: "Recordable injuries (Number of cases)",
  446: "Recordable work-related ill health cases (Number of cases)",
  447: "Number of Environmental Incidents",
  449: "Total GHG emissions due to consumption of LPG",
  450: "Total LPG cost* (in Rs.)",
  468: "Total electricity consumption (GRID electricity)* (in KWh)",
  469: "Total Tanker Water Consumption* (in KL)",
  // 470: "Total water consumption limit as per Consent to Operate*( in KLD)",
  471: "Total groundwater consumption limit as per CGWA NOC* ( in KLD)",
  472: "Number of deviations reported in terms of water consumption with respect to CTO limit* ",
  473: "Number of deviations reported in terms of water consumption with respect to CGWA limit* ",
  474: "Total surface water consumption (this includes municipal supply water)* ( in KL)",
  475: "Zero Liquid Discharge (ZLD)*(Yes/No)",
  485: "How many deviations observed in ambient air quality report appeared* ",
  486: "Total number of significant deviations reported in the environmental monitoring reports with respect to applicable regulatory standard or permits* ",
  487: "Number of deviations observed in ambient air quality report* ",
  488: "Number of deviations observed in ambient noise level report* ",
  489: "Number of deviations  observed in air emissions reports (stacks) appeared*",
  490: "Number of deviations observed in air emissions reports (Diesel Generator)* ",
  491: "Number of deviations observed in drinking water quality report* ",
  492: "Number of deviations observed in treated wastewater quality report* ",
  493: "Number of deviations observed in groundwater quality report for waste sector*",
  494: "Number of deviations observed in soil quality report for waste sector",
  495: "Total Furnace oil (FO) consumed within the operational boundary of the company*   (in Liters)",
  496: "Total GHG emissions due to consumption of FO",
  497: "Total Coal consumed within the operational boundary of the company*   (in Kg)",
  498: "Total GHG emissions due to consumption of Coal",
  499: "Total Briquette consumed within the operational boundary of the company*  (in Kg)",
  500: "Total GHG emissions due to consumption of briquette",
  501: "Number of  New hires by Gender Male",
  502: "Number of New hires by Gender Female ",
  503: "Number of New hires by age groups (30-50) ",
  504: "Number of New hires by age groups (>50)",
  507: "Testing and Certification of Lift(No. of lifts/No. of tests)",
  512: "Total Nitrous Oxide (N₂O) consumed within the operational boundary of the company*  (in Liters)",
  513: "Total Carbon Dioxide (CO₂) consumed within the operational boundary of the company*  (in Kgs)",
  514: "Total Entonox consumed within the operational boundary of the company*  (in Kgs)",
  515: "Total Desflurane consumed within the operational boundary of the company*  (in ml)",
  516: "Total Isoflurane consumed within the operational boundary of the company*  (in ml)",
  517: "Total Sevoflurane consumed within the operational boundary of the company*  (in ml)",
  518: "Total R-134A consumed within the operational boundary of the company*  (in Kgs)",
  519: "Total R-22 consumed within the operational boundary of the company*  (in Kgs)",
  520: "Total R-407C consumed within the operational boundary of the company*  (in Kgs)",
  521: "Total R-32 consumed within the operational boundary of the company*  (in Kgs)",
  522: "Total R-410A consumed within the operational boundary of the company*  (in Kgs)",
  523: "Total Sevitrue consumed within the operational boundary of the company*  (in ml)",
  524: "Total Suprane consumed within the operational boundary of the company*  (in ml)",
  526: "Total Sevorane consumed within the operational boundary of the company*  (in ml)",
  527: "Total Water consumption (Ground water+municipal supply water+tanker water)*( in KL)",
  528: "Total Electrical Consumption(Total of all above sources of Electricity Consumed)*  in KWh",
  529: "Greenhouse Gas Emissions Scope-1",
  530: "Greenhouse Gas Emissions - Scope 2 ",
  531: "Number of New hires by age groups (<30) ",
  532: "Diesel Energy within Operational Boundaries (in GJ)",
  533: "LPG Energy within Operational Boundaries (in GJ)",
  534: "Petrol Energy within Operational Boundaries (in GJ)",
  536: "PNG Energy within Operational Boundaries (in GJ)",
  537: "Electricity from Captive Power Plant (Natural Gas) (in GJ)",
  538: "Electricity Consumption through DG (in GJ)",
  539: "Total Electricity Consumption from Renewable Energy (via PPA) (in GJ)",
  540: "Total Electricity Consumption from Renewable Energy (Rooftop Solar) (in GJ)",
  541: "Total Electricity Consumption (Grid Electricity) (in GJ)",
  542: "Furnace Oil (FO) Energy within Operational Boundaries (in GJ)",
  543: "Coal Energy within Operational Boundaries (in GJ)",
  544: "Briquette Energy within Operational Boundaries (in GJ)",
  545: "Total packaging waste (Non-Plastic-Paper waste) generated* (Kg)",
  546: "Total iron waste generated * Kg",
  547: "Total Aluminum waste generated * Kg",
  548: "Total Copper waste generated * Kg",
  549: "Total food waste converted to manure through organic waste converter (OWC)* (Kgs)",
  550: "Total waste oil generated (cooking oil/diesel oil) in Ltrs",
  551: "Total spent formalin solution disposed in Ltrs",
  552: "Total number of employees (FTE)",
  448: "Number of IP days",
  582: "% of occupancy",
  583: "Total approved beds",
  584: "Total operating beds",
  585: "Total built up area (sq.ft)",
  586: "Total number of contract employees",
  587: "Total number of outsource employees",
  589: "Total CO2 extinguishers used within the operational boundary of the company*  (in Kgs)"
};

const ExcelUploader = ({ financialYearId }) => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [months, setMonths] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const multiselectRef = useRef();
  const [loading, setLoading] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [periodLockData, setPeriodLockData] = useState([]);
  const fetchData = async (financialYearId) => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}periods/locked`,
        {},
        { financialYearId },
        "GET"
      );
      if (isSuccess) {
        setPeriodLockData(data?.data)
      } else {
        setPeriodLockData([]);
      }
    } catch (error) {
      setPeriodLockData([]);
    }
  };

  useEffect(() => {
    if (financialYearId)
      fetchData(financialYearId)
  }, [financialYearId]);

  const getLocations = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}getSource`,
        {},
        {},
        "GET"
      );

      if (isSuccess && data?.data) {
        const locationOptions = [];

        data.data.forEach((item) => {
          const subLocations = item.subLocation || [];

          if (subLocations.length > 0) {
            subLocations.forEach((sub) => {
              locationOptions.push({
                id: `${item.id}-${sub.id}`,
                name: `${item.unitCode}-${sub.subLocation}`,
                subLocations: [],
              });
            });
          } else {
            locationOptions.push({
              id: item.id,
              name: item.unitCode,
              subLocations: [],
            });
          }
        });

        console.log(locationOptions, "locationOptions");
        setLocations(locationOptions);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  const excelSerialToDate = (serial) => {
    if (typeof serial !== "number") return serial;
    const excelEpoch = new Date(1899, 11, 30);
    const parsedDate = new Date(excelEpoch.getTime() + serial * 86400000);
    return parsedDate.toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    const generateMonths = () => {
      const startMonth = 3; // April (0-based index)
      const startYear = 2025;
      const monthsArray = [];

      for (let i = 0; i < 12; i++) {
        const date = new Date(startYear, startMonth + i, 1);
        const formattedMonth = date
          .toLocaleDateString("en-US", { month: "2-digit", year: "numeric" })
          .replace(",", "");
        const abbreviatedMonth = date.toLocaleDateString("en-US", {
          month: "short",
        });

        const formatDateKey = (date) => {
          const [year, month] = date.split("-");
          return `${month}/${year}`;
        };

        const period = periodLockData.find(p => formatDateKey(p.fromDate) === formattedMonth);
        const currentUser = JSON.parse(localStorage.getItem("currentUser"));
        const userId = currentUser?.id;
        if (period) {
          if (period && period.allowedUsers.includes(userId)) {
            monthsArray.push({
              name: formattedMonth,
              displayName: abbreviatedMonth,
            });
          } else {
          }
        } else {
          monthsArray.push({
            name: formattedMonth,
            displayName: abbreviatedMonth,
          });
        }
      }
      console.log(monthsArray, "monthsArraymonthsArray")
      setMonths(monthsArray);
    };
    getLocations();
    generateMonths();
  }, []);

  // Add the handleSave function
  const handleSave = async () => {
    // Validation
    if (!selectedLocation) {
      sweetAlert("error", "Please select a location");
      return;
    }

    if (selectedMonths.length === 0) {
      sweetAlert("error", "Please select at least one month");
      return;
    }

    if (!selectedFile) {
      sweetAlert("error", "Please upload an Excel file");
      return;
    }

    // Trigger the file processing
    await processSelectedFile();
  };


  const processSelectedFile = async () => {
    if (!selectedFile) return;

    setLoading(true);
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (jsonData.length === 0) {
          sweetAlert("error", "Excel file is empty");
          setLoading(false);
          return;
        }

        let headers = jsonData[2] || [];
        headers = headers.map((col) => excelSerialToDate(col));

        const selectedMonthNames = selectedMonths.map((m) => m.name);

        let extractedData = [];
        for (let i = 3; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (!row[1]) continue;

          let kpiData = {
            question: row[1],
            data: {},
          };

          for (let j = 3; j < headers.length; j++) {
            if (headers[j] && selectedMonthNames.includes(headers[j])) {
              kpiData.data[headers[j]] = row[j];
            }
          }

          extractedData.push(kpiData);
        }

        await generatePayload(extractedData, selectedMonthNames, questionData);
      } catch (error) {
        console.error("Error processing file:", error);
        sweetAlert("error", "Error processing Excel file");
        setLoading(false);
      }
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];

    if (!allowedTypes.includes(file.type)) {
      sweetAlert("error", "Please select a valid Excel file (.xlsx or .xls)");
      event.target.value = '';
      return;
    }

    // Validate file size (e.g., max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
      sweetAlert("error", "File size must be less than 10MB");
      event.target.value = '';
      return;
    }

    setSelectedFile(file);
    console.log('File selected:', file.name);
  };

  const getDataByQuestionAndMonth = (question, month, dataArray) => {
    const entry = dataArray.find((item) => item.question === question);
    return entry
      ? entry.data[month] || "Data not available"
      : "Question not found";
  };

  const generatePayload = async (
    extractedData,
    selectedMonthNames,
    questionData
  ) => {
    if (!selectedLocation) {
      console.warn("No location selected.");
      return;
    }

    try {
      for (const item of extractedData) {
        const questionId = Object.keys(questionData).find((key) =>
          questionData[key]
            .toLowerCase()
            .replace(/\s+/g, "") === item.question.toLowerCase().replace(/\s+/g, "")
        );
        if (!questionId) {
          console.warn(`No questionId found for: ${item.question}`);
          continue;
        }

        for (const month of selectedMonthNames) {
          // Extract year and month from "MM/YYYY"
          const [mm, yyyy] = month.split("/").map(Number);
          const fromDate = `${yyyy}-${String(mm).padStart(2, "0")}`;

          // Calculate next month for toDate
          let nextMonth = mm + 1;
          let nextYear = yyyy;
          if (nextMonth > 12) {
            nextMonth = 1;
            nextYear++;
          }
          const toDate = `${nextYear}-${String(nextMonth).padStart(2, "0")}`;

          if (item.data[month] !== undefined) {
            let answer = [[""]]; // Default answer

            function safeFixed(value, multiplier = 1, decimals = 2) {
              const num = Number(value);
              return isNaN(num) ? value : (num * multiplier).toFixed(decimals);
            }

            if (Number(questionId) === 409) {
              answer = [[
                getDataByQuestionAndMonth("Yellow in (Kg)", month, extractedData),
                getDataByQuestionAndMonth("Red (Kg)", month, extractedData),
                getDataByQuestionAndMonth("White (Kg)", month, extractedData),
                getDataByQuestionAndMonth("Blue (Kg)", month, extractedData),
                getDataByQuestionAndMonth("Cytotoxic (kgs)", month, extractedData),
              ]];
            } else if (Number(questionId) === 505) {
              answer = [[
                getDataByQuestionAndMonth(
                  "Average training hours per employee by gender Male (in Hours/Number of employees))",
                  month,
                  extractedData
                ),
              ], [
                getDataByQuestionAndMonth(
                  "Average training hours per employee by gender Female (in Hours/Number of employees))",
                  month,
                  extractedData
                ),
              ]];
            } else if ([402, 509].includes(Number(questionId))) {
              answer = [["", "", safeFixed(item?.data[month])]];
            } else if (Number(questionId) === 437) {
              answer = [["", safeFixed(item?.data[month])]];
            } else if ([508, 510].includes(Number(questionId))) {
              answer = [[safeFixed(item?.data[month]), ""]];
            } else if ([501, 502, 503].includes(Number(questionId))) {
              answer = [[safeFixed(item?.data[month]), ""]];
            } else if ([504, 531].includes(Number(questionId))) {
              answer = [["", "", safeFixed(item?.data[month])]];
            }

            let readingValue = item?.data[month];
            if ([432, 433, 434, 435, 436].includes(Number(questionId))) {
              const num = Number(item?.data[month]);
              readingValue = isNaN(num) ? item?.data[month] : num;
            }


            // Parse selectedLocation into sourceId and subLocationId
            let sourceId = null;
            let subLocationId = null;

            if (selectedLocation && selectedLocation.includes("-")) {
              const [source, sub] = selectedLocation.split("-").map(Number);
              sourceId = source;
              subLocationId = sub;
            } else {
              sourceId = Number(selectedLocation);
              subLocationId = null;
            }

            let payload = {
              questionId: Number(questionId),
              moduleId: 12,
              questionType: [
                409, 402, 437, 501, 502, 503, 504, 505, 508, 509, 510, 531,
              ].includes(Number(questionId))
                ? "tabular_question"
                : [475, 476].includes(Number(questionId))
                  ? "yes_no"
                  : "quantitative_trends",
              questionTitle: item.question,
              fromDate: fromDate,
              toDate: toDate,
              frequency: "CUSTOM",
              readingValue,
              unit: "KL",
              sourceId: sourceId,
              subLocationId: subLocationId,
              notApplicable: readingValue === "NA",
              financialYearId: financialYearId,
              current_role: "company",
              note: [[""]],
              proofDocument: [[]],
              comment: [[]],
              answer: [
                409, 402, 437, 501, 502, 503, 504, 505, 508, 509, 510, 531,
              ].includes(Number(questionId))
                ? JSON.stringify(answer)
                : [475, 476].includes(Number(questionId))
                  ? JSON.stringify({
                    answer: readingValue,
                  })
                  : JSON.stringify({
                    questionId: Number(questionId),
                    moduleId: 12,
                    questionType: [
                      409, 402, 437, 501, 502, 503, 504, 505, 508, 509, 510, 531,
                    ].includes(Number(questionId))
                      ? "tabular_question"
                      : "quantitative_trends",
                    questionTitle: item.question,
                    fromDate: fromDate,
                    toDate: toDate,
                    frequency: "CUSTOM",
                    readingValue:
                      typeof readingValue === "number"
                        ? readingValue.toFixed(2)
                        : readingValue,
                    unit: "KL",
                  }),
            };

            await handleSubmit(payload);
          }
        }
      }

      // Reset form after successful upload
      setSelectedLocation("");
      setSelectedMonths([]);
      setSelectedFile(null);
      setModalOpen(false);
      sweetAlert("success", "Your Data successfully Uploaded");

    } catch (error) {
      console.error("Error in generatePayload:", error);
      sweetAlert("error", "Error uploading data");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (payload) => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}saveAnswerReportingQuestions`,
        {},
        payload,
        "POST"
      );

      if (isSuccess) {
        console.log("Payload submitted successfully:", data);
      } else {
        console.warn("Failed to submit payload.");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <Button
        style={{
          backgroundColor: "#3F88A5",
          border: "none",
          borderRadius: "4px",
          height: "37px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setModalOpen(true)}
      >
        Upload
      </Button>

      {/* Modal for Selecting Location and Uploading File */}
      <Modal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-dark fs-4">
            <i className="bi bi-geo-alt-fill text-primary me-2"></i>
            Select Location & Upload Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-3">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted fs-5">Uploading your file...</p>
              <div
                className="progress mx-auto"
                style={{ width: "60%", height: "6px" }}
              >
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                  role="progressbar"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </div>
          ) : (
            <Form>
              {/* Location Selection */}
              <div className="mb-4">
                <Form.Group controlId="locationSelect">
                  <Form.Label className="fw-semibold text-dark mb-2 d-flex align-items-center">
                    <i className="bi bi-building me-2 text-primary"></i>
                    Choose a Location
                  </Form.Label>
                  <Form.Select
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                    className="form-select-lg border-2 shadow-sm"
                    style={{
                      borderColor: "#e3f2fd",
                      borderRadius: "12px",
                      padding: "12px 16px",
                      fontSize: "16px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <option value="" className="text-muted">
                      Select a location
                    </option>
                    {locations.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              {/* Month Selection */}
              <div className="mb-4">
                <Form.Group controlId="monthSelect">
                  <Form.Label className="fw-semibold text-dark mb-2 d-flex align-items-center">
                    <i className="bi bi-calendar3 me-2 text-primary"></i>
                    Select Month(s)
                  </Form.Label>
                  <div className="position-relative">
                    <Multiselect
                      placeholder="Choose months to analyze"
                      displayValue="displayName"
                      options={months}
                      selectedValues={selectedMonths}
                      onRemove={setSelectedMonths}
                      onSelect={setSelectedMonths}
                      showCheckbox
                      ref={multiselectRef}
                      style={{
                        chips: {
                          background: "#3F88A5",
                          borderRadius: "20px",
                          padding: "4px 12px",
                          margin: "2px",
                          fontSize: "14px",
                        },
                        searchBox: {
                          border: "2px solid #e3f2fd",
                          borderRadius: "12px",
                          padding: "8px 16px",
                          fontSize: "16px",
                          minHeight: "48px",
                        },
                        option: {
                          padding: "12px 16px",
                          fontSize: "15px",
                        },
                        optionContainer: {
                          borderRadius: "12px",
                          border: "1px solid #e0e0e0",
                          marginTop: "4px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        },
                      }}
                    />
                  </div>
                </Form.Group>
              </div>

              {/* File Upload */}
              <div className="mb-3">
                <Form.Group controlId="fileUpload">
                  <Form.Label className="fw-semibold text-dark mb-2 d-flex align-items-center">
                    <i className="bi bi-cloud-upload me-2 text-primary"></i>
                    Upload Excel File
                  </Form.Label>
                  <div
                    className="upload-area border-2 border-dashed rounded-3 p-4 text-center position-relative"
                    style={{
                      borderColor: "#3F88A5",
                      backgroundColor: "#f8fcff",
                      transition: "all 0.3s ease",
                      minHeight: "120px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#2196F3";
                      e.currentTarget.style.backgroundColor = "#e3f2fd";
                    }}
                    onDragLeave={(e) => {
                      e.currentTarget.style.borderColor = "#3F88A5";
                      e.currentTarget.style.backgroundColor = "#f8fcff";
                    }}
                  >
                    <i className="bi bi-file-earmark-excel text-success fs-1 mb-2"></i>
                    <p className="text-muted mb-2">
                      <strong>Drag & drop</strong> your Excel file here, or
                      <span className="text-primary ms-1">browse</span>
                    </p>
                    <small className="text-muted">
                      Supports .xlsx and .xls files
                    </small>
                    {selectedFile && (
                      <div className="mt-2">
                        <small className="text-success">
                          <i className="bi bi-check-circle me-1"></i>
                          Selected: {selectedFile.name}
                        </small>
                      </div>
                    )}
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileUpload}
                      className="position-absolute w-100 h-100 opacity-0"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </Form.Group>
              </div>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 px-4 pb-4">
          <div className="w-100 d-flex justify-content-end gap-2">
            <Button
              variant="outline-secondary"
              onClick={() => {
                setModalOpen(false);
                setSelectedFile(null);
              }}
              className="px-4 py-2 rounded-3 fw-semibold"
              style={{
                borderColor: "#dee2e6",
                color: "#6c757d",
                transition: "all 0.3s ease",
              }}
            >
              <i className="bi bi-x-circle me-1"></i>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSave}
              disabled={
                !selectedLocation || selectedMonths.length === 0 || !selectedFile || loading
              }
              className="px-4 py-2 rounded-3 fw-semibold shadow-sm"
              style={{
                backgroundColor: "#3F88A5",
                border: "none",
                transition: "all 0.3s ease",
                opacity:
                  !selectedLocation || selectedMonths.length === 0 || !selectedFile || loading
                    ? 0.6
                    : 1,
              }}
            >
              <i className="bi bi-save me-1"></i>
              Save & Upload
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ExcelUploader;